export default __webpack_public_path__ + "static/media/PageLoader.330098ce.svg";